import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import PortImg1 from "../../../images/background/back_service.jpg"
import PortImg2 from "../../../images/portfolio/agriculture/image_2.jpg"
import PortImg3 from "../../../images/portfolio/agriculture/image_3.jpg"
import PortImg4 from "../../../images/portfolio/agriculture/image_4.jpg"
import PortImg5 from "../../../images/portfolio/agriculture/image_5.jpg"
import PortImg6 from "../../../images/portfolio/agriculture/image_6.jpg"

class Services3 extends Component{
	render(){
		return(
			<>
				<div className="section-area bg-white section-sp2" >
					<div className="container">

						<div className="heading-bx text-center">
							<h6 className="title-ext m-b0">Our Services</h6>
							<h2 className="title-head m-b0">Range of services <br/>and solutions</h2>
							<div className="ttr-separator sepimg"></div>
						</div>

						<div className="row">
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.2s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-light-bolt"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{ fontSize: 20 }}>
											Electrical Energy Services
										</h4>
										<p style={{ fontSize: 14 }}>
											Engineering and technical support for MV/LV networks, substations,
											power quality, and energy efficiency solutions.
										</p>
										<Link to="SolutionEnergy" className="btn-link">
											Read More
										</Link>
									</div>

									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.2s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-gears"></i></Link> 
									</div>
									<div className="icon-content">
									<h4 className="ttr-tilte" style={{ fontSize: 20 }}>
										Automation & SCADA Systems
									</h4>
									<p style={{ fontSize: 14 }}>
										Advanced automation and SCADA solutions for real-time monitoring,
										control .
										<br/>
										<br/>
									</p>
									<Link to="SolutionEnergy" className="btn-link">
										Read More
									</Link>
								</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.2s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-flashlight"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Geological & Reservoir Analysis</h4>
										<p style={{fontSize:14}}>High-precision geological, seismic, and reservoir evaluations for accurate resource estimation.</p>
										<Link to="SolutionGeologicalReservoirAnalysis" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.4s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-flask"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Reservoir Stimulation & Activation</h4>
										<p style={{fontSize:14}}>Advanced chemical and nano-assisted treatments designed to unlock hydrocarbons and enhance overall recovery.</p>
										<Link to="SolutionGeophysicalServices" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.4s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-analytics"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Advanced Production Optimization</h4>
										<p style={{fontSize:14}}>Nano-tech and AI-driven EOR methods to maximize production and improve efficiency.</p>
										<Link to="SolutionRenewableEnergy" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.6s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-driller"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Drilling & Production Supply Chain</h4>
										<p style={{fontSize:14}}>Reliable supply of drilling, completion, and production equipment and eco-friendly chemicals.<br/> <br/></p>
										<a href="SolutionIndustrialMaintenance" className="btn-link">Read More</a>
									</div>
									<div className="bg-img" style={{backgroundImage: "url("+PortImg1+")" }}></div>
								</div>
							</div>

							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.4s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-factory"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Facility Management & Problem Solving</h4>
										<p style={{fontSize:14}} >AI-powered facility oversight and predictive maintenance to reduce downtime and costs.<br/> <br/> <br/></p>
										<Link to="SolutionEnvironmentalHSE" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.6s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-barrier"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Integrity Management for Wells & Facilities</h4>
										<p style={{fontSize:14}}>Corrosion control and integrity testing  supported by AI models for long-term asset safety.<br/><br/></p>
										<a href="SolutionEnvironmentalHSE" className="btn-link">Read More</a>
									</div>
									<div className="bg-img" style={{backgroundImage: "url("+PortImg1+")" }}></div>
								</div>
							</div>
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.6s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-maintenance"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Well Maintenance & Cleaning</h4>
										<p style={{fontSize:14}}>Efficient downhole and surface cleaning methods that restore flow performance and extend the life of your wells.</p>
										<Link to="SolutionDrillingEngineering" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div>
							<div className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeIn" data-wow-delay="0.2s">
								<div className="feature-container feature-bx1">
									<div className="feature-lg text-white m-b20">
										<Link to="#" className="icon-cell"><i className="flaticon-speedometer"></i></Link> 
									</div>
									<div className="icon-content">
										<h4 className="ttr-tilte" style={{fontSize:20}}>Real-Time Well Monitoring</h4>
										<p style={{fontSize:14}}>Continuous digital monitoring and AI analysis ensuring early issue detection and optimized field operations.</p>
										<Link to="SolutionProductionOptimization" className="btn-link">Read More</Link>
									</div>
									<div className="bg-img" style={{backgroundImage:"url("+PortImg1+")"}}></div>
								</div>
							</div> 
							<div className="col-lg-12 text-center m-t20 m-sm-t0" data-wow-delay="0.6s">
								<Link to="SolutionGeologicalReservoirAnalysis" className="btn">View All Service</Link>
							</div>
						</div>
					</div>
					
				</div>
			</>
		);
	}
}

export default Services3;
